// Fetch SMEs
export const FETCH_SMES_REQUEST = 'FETCH_SMES_REQUEST';
export const FETCH_SMES_SUCCESS = 'FETCH_SMES_SUCCESS';
export const FETCH_SMES_FAILURE = 'FETCH_SMES_FAILURE';

// Create SME
export const CREATE_SME_REQUEST = 'CREATE_SME_REQUEST';
export const CREATE_SME_SUCCESS = 'CREATE_SME_SUCCESS';
export const CREATE_SME_FAILURE = 'CREATE_SME_FAILURE';

// Delete SME
export const DELETE_SME_REQUEST = 'DELETE_SME_REQUEST';
export const DELETE_SME_SUCCESS = 'DELETE_SME_SUCCESS';
export const DELETE_SME_FAILURE = 'DELETE_SME_FAILURE';

// Update SME
export const UPDATE_SME_REQUEST = 'UPDATE_SME_REQUEST';
export const UPDATE_SME_SUCCESS = 'UPDATE_SME_SUCCESS';
export const UPDATE_SME_FAILURE = 'UPDATE_SME_FAILURE';